var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFilterOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 4,
    width: 3,
    height: 1.4,
    transform: "rotate(90 19 4)",
    fill: "#407DD8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 10,
    width: 10,
    height: 1.4,
    transform: "rotate(90 19 10)",
    fill: "#407DD8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 4,
    width: 10,
    height: 1.4,
    transform: "rotate(90 13 4)",
    fill: "#407DD8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 17,
    width: 3,
    height: 1.4,
    transform: "rotate(90 13 17)",
    fill: "#407DD8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 5,
    height: 1.4,
    transform: "rotate(90 7 4)",
    fill: "#407DD8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12,
    width: 8,
    height: 1.4,
    transform: "rotate(90 7 12)",
    fill: "#407DD8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8008 8.5C15.8008 9.88071 16.9201 11 18.3008 11C19.6815 11 20.8008 9.88071 20.8008 8.5C20.8008 7.11929 19.6815 6 18.3008 6C16.9201 6 15.8008 7.11929 15.8008 8.5ZM17.3008 8.5C17.3008 9.05228 17.7485 9.5 18.3008 9.5C18.8531 9.5 19.3008 9.05228 19.3008 8.5C19.3008 7.94772 18.8531 7.5 18.3008 7.5C17.7485 7.5 17.3008 7.94772 17.3008 8.5Z",
    fill: "#407DD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80078 15.5C9.80078 16.8807 10.9201 18 12.3008 18C13.6815 18 14.8008 16.8807 14.8008 15.5C14.8008 14.1193 13.6815 13 12.3008 13C10.9201 13 9.80078 14.1193 9.80078 15.5ZM11.3008 15.5C11.3008 16.0523 11.7485 16.5 12.3008 16.5C12.8531 16.5 13.3008 16.0523 13.3008 15.5C13.3008 14.9477 12.8531 14.5 12.3008 14.5C11.7485 14.5 11.3008 14.9477 11.3008 15.5Z",
    fill: "#407DD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.80078 10.5C3.80078 11.8807 4.92007 13 6.30078 13C7.68149 13 8.80078 11.8807 8.80078 10.5C8.80078 9.11929 7.68149 8 6.30078 8C4.92007 8 3.80078 9.11929 3.80078 10.5ZM5.30077 10.5C5.30077 11.0523 5.74849 11.5 6.30077 11.5C6.85306 11.5 7.30078 11.0523 7.30078 10.5C7.30078 9.94772 6.85306 9.5 6.30077 9.5C5.74849 9.5 5.30077 9.94772 5.30077 10.5Z",
    fill: "#407DD8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterOn);
export default __webpack_public_path__ + "static/media/icon_filter_on.ead68f5b2eec40a0bafdc58c63f12ec7.svg";
export { ForwardRef as ReactComponent };